var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('wrap-container',{staticClass:"w100"},[_c('footer',[_c('p',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.config.pasos.paso1.footer),expression:"config.pasos.paso1.footer"}]})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }